module.exports = __webpack_public_path__ + "static/media/frank.b88b0dae.jpg";